var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component, createRef } from 'react';
export class FileDropZoneInput extends Component {
    constructor() {
        super(...arguments);
        this.fileInputNode = createRef();
        this.triggerFileDialog = () => {
            this.open();
            if (this.props.onFileDialogClose) {
                this.props.onFileDialogClose();
            }
        };
        this.open = () => {
            if (!this.fileInputNode.current)
                return;
            this.fileInputNode.current.click();
        };
    }
    componentDidMount() {
        const { openFileDialog } = this.props;
        if (openFileDialog) {
            this.triggerFileDialog();
        }
    }
    componentDidUpdate() {
        const { openFileDialog } = this.props;
        if (openFileDialog) {
            this.triggerFileDialog();
        }
    }
    render() {
        const _a = this.props, { openFileDialog, onFileDialogClose } = _a, inputProps = __rest(_a, ["openFileDialog", "onFileDialogClose"]);
        return React.createElement("input", Object.assign({}, inputProps, { ref: this.fileInputNode, autoComplete: "off" }));
    }
}
//# sourceMappingURL=FileDropZoneInput.js.map